var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"radio","id":"item.key","name":"patinent_select"}}),_c('label',{attrs:{"for":"item.key"}},[_c('span')])])
}]

export { render, staticRenderFns }